import { Injectable } from "@angular/core";
import { AuthenticationService } from "app/services/authentication.service";
import { HttpClient } from "@angular/common/http";
import { Baseservice } from "app/services/baseservice";
import { environment } from "environments/environment";
import { map, takeUntil } from "rxjs/operators";
@Injectable({
  providedIn: "root",
})
export class OcasService {
  protected url: string = environment.iCBMSWebApi.url;
  public stage: string = 'depot';
  constructor(private http: HttpClient) {}
  getQuestionnaires() {
    return this.http.get(this.url + "ocastype/document");
  }
  postQuestionnaires(body: any) {
    return this.http.post(this.url + "carrierocastype", body);
  }
  uploadDocument(formData: any) {
    return this.http.post(
      this.url + "carrier-ocas-type/document/upload",
      formData
    );
  }

  getSavedQuestionnaireById(id: number) {
    return this.http.get(`${this.url}carrier-ocas-type/document/${id}`);
  }
  deleteDocumentFormList(id: number) {
    return this.http.delete(
      `${this.url}carrier-ocas-type/document/delete/${id}`
    );
  }
  downloadpdf(id) {
    return this.http
      .get(this.url + "document/download/" + id, { responseType: "blob" })
      .pipe(
        map((res: any) => {
          return new Blob([res], { type: "application/pdf" });
        })
      );
  }
  getAuditQuestionnaires() {
    return this.http.get(this.url + "ocastype/audit");
  }
}
